





















































































import Vue from 'vue'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling, DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { hexToRgba } from '@/services/hex-to-rgba'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import { Color, ConfigurationDescriptionLanguage, UiLanguageItem, UiLanguageList } from '@/types'
import DescriptionLanguagesDialog from '@/components/settings/configuration/DescriptionLanguagesDialog.vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ColorPicker from '@/components/ColorPicker.vue'
import { GetArbeitenResponse, ResponseBase } from '@/types/service-response'
import {
  CREATE_MASTER_DATA_WORK_LIST,
  DELETE_MASTER_DATA_WORK_LIST, EDIT_MASTER_DATA_WORK_LIST,
  FETCH_MASTER_DATA_WORK_LIST
} from '@/store/action-types'
import { Work } from '@/model/master-data/Work'
import { WorkDescription } from '@/model/master-data/WorkDescription'
import { CreateMasterDataWorkPayload, EditMasterDataWorkPayload } from '@/types/payload'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}
class Save extends KeyAction {}
class Cancel extends KeyAction {}

interface ComponentData {
  rules: Function[]
  loading: boolean
  saveLoading: boolean
  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  showDeleteDialog: boolean
  showDescriptionLanguagesDialog: boolean

  isEdit: boolean

  tableHeight: string
  selectedConfigurationIndex: number | null
  selectedConfiguration: Work | null
  configurationList: Work[]

  code: string | null
  bezeichnung: string | null
  languagesDialogDescriptionData: ConfigurationDescriptionLanguage[]
  color: string

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ConfigurationForm111',

  components: {
    ProgressCircular,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    DeleteDialog,
    DescriptionLanguagesDialog,
    ColorPicker
  },

  props: { },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()],
      loading: false,
      saveLoading: false,
      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      showDeleteDialog: false,
      showDescriptionLanguagesDialog: false,

      isEdit: false,

      tableHeight: '',
      selectedConfigurationIndex: null,
      selectedConfiguration: null,
      configurationList: [],

      code: null,
      bezeichnung: null,
      languagesDialogDescriptionData: [],
      color: '#000000',

      keyActions: []
    }
  },

  watch: {
    isEdit (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      } else {
        setTimeout(() => {
          const focusedButton: any = this.$refs['focusedButton']
          if (focusedButton) {
            focusedButton.$el.focus()
          }
        }, 0)
      }
    },

    bezeichnung (newVal: string | null): void {
      let foundText: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      if(foundText) {
        foundText.text =  newVal ? newVal : ''
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    isDisabledInsertButton (): boolean {
      return this.saveLoading || this.isEdit
    },

    isDisabledUpdateButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    },

    isDisabledDeleteButton (): boolean {
      return !this.selectedConfiguration || this.isEdit
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | Save | Cancel | null): boolean {
      if(action instanceof Create) {
        return !this.isDisabledInsertButton
      } else if(action instanceof Edit) {
        return !this.isDisabledUpdateButton
      } else if(action instanceof Delete) {
        return !this.isDisabledDeleteButton
      } else if(action instanceof Save) {
        return this.isEdit && !this.saveLoading
      } else if(action instanceof Cancel) {
        return this.isEdit && !this.saveLoading
      } else {
        return false
      }
    },

    onDescriptionLanguagesClick (): void {
      this.showDescriptionLanguagesDialog = true
    },

    onDescriptionLanguagesDialogSave (data: ConfigurationDescriptionLanguage[]): void {
      this.languagesDialogDescriptionData = data
      const foundDescription: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((item: ConfigurationDescriptionLanguage) => item.languageId === this.selectedLanguageId)
      this.bezeichnung = foundDescription ? foundDescription.text : null
      this.onDescriptionLanguagesDialogClose()
    },

    onDescriptionLanguagesDialogClose (): void {
      this.showDescriptionLanguagesDialog = false
    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        this.color = color.hex
      }
    },

    onAddConfigurationClick (): void {
      this.isEdit = true
      this.selectedConfigurationIndex = null
      this.selectedConfiguration = null
      //@ts-ignore
      setTimeout(() => {this.$refs.dataGrid.instance.selectRows([])}, 100)
      this.code = null
      this.bezeichnung = null
      this.color = '#000000'
      this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
        return {
          languageId: item.syzId,
          text: ''
        }
      })
      const form: any = this.$refs['form']
      form.resetValidation()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddConfigurationClick()
    },

    onEditConfigurationsClick (): void {
      this.isEdit = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditConfigurationsClick()
    },

    onDeleteConfigurationClick () {
      if (this.selectedConfiguration && !this.selectedConfiguration.isErasable) {
        this.messageSnackbar = this.$t('masterData.work.theWorkCouldNotBeDeleted').toString().replace('%s', `"${this.selectedConfiguration.getDescriptionLabel}"`)
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } else {
        this.showDeleteDialog = true
      }
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteConfigurationClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.deleteConfiguration()
    },

    onRowClick (rowData: any): void {
      this.isEdit = false
      this.selectedConfigurationIndex = this.configurationList.indexOf(rowData.data)
      this.selectedConfiguration = rowData.data
      this.setForm()
    },

    onCancelClick (): void {
      this.isEdit = false
      this.setForm()
    },

    cancel (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onCancelClick()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if (form.validate()) {
        if (this.selectedConfiguration) {
          this.updateConfiguration()
        } else {
          this.createConfiguration()
        }
      }
    },

    save (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onSaveButtonClick()
    },

    async createConfiguration (): Promise<void> {
      const payload: CreateMasterDataWorkPayload = {
        Code: this.code!,
        Farbe: this.color,
        Items: this.languagesDialogDescriptionData.map((item: ConfigurationDescriptionLanguage) => {
          return {
            Sprache: item.languageId,
            Bezeichnung: item.text
          }
        })
      }

      this.saveLoading = true
      try {
        const response: ResponseBase = await this.$store.dispatch(CREATE_MASTER_DATA_WORK_LIST, payload)
        this.saveLoading = false
        if(response && !response.IsError) {
          this.isEdit = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchConfigurationList()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.saveLoading = false
        this.messageSnackbar = this.$t('masterData.work.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async updateConfiguration (): Promise<void> {
      const payload: EditMasterDataWorkPayload = {
        Item: {
          ID: this.selectedConfiguration!.id,
          Code: this.code!,
          Farbe: this.color,
          Bezeichnungen: this.selectedConfiguration!.descriptionList.map((item: WorkDescription) => {
            const foundDescription: ConfigurationDescriptionLanguage | undefined = this.languagesDialogDescriptionData.find((i: ConfigurationDescriptionLanguage) => i.languageId === item.language)
            return {
              ID: item.id,
              Sprache: item.language,
              Arbeit: this.selectedConfiguration!.id,
              Bezeichnung: foundDescription ? foundDescription.text : ''
            }
          })
        }
      }

      this.saveLoading = true
      try {
        const response: ResponseBase = await this.$store.dispatch(EDIT_MASTER_DATA_WORK_LIST, payload)
        this.saveLoading = false
        if(response && !response.IsError) {
          this.isEdit = false
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataHaveBeenSaved').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchConfigurationList()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('masterData.work.dataCouldNotBeSaved').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.saveLoading = false
        this.messageSnackbar = this.$t('masterData.work.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async deleteConfiguration (): Promise<void> {
      try {
        const response: ResponseBase = await this.$store.dispatch(DELETE_MASTER_DATA_WORK_LIST, this.selectedConfiguration!.id)
        if(response && !response.IsError) {
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.onDeleteDialogClose()
          this.selectedConfigurationIndex = null
          this.selectedConfiguration = null
          this.fetchConfigurationList()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchConfigurationList (): Promise<void> {
      try {
        this.loading = true
        const response: GetArbeitenResponse = await this.$store.dispatch(FETCH_MASTER_DATA_WORK_LIST)
        this.loading = false
        if(response && !response.IsError) {
          this.configurationList = Work.createListFromResponse(response.Arbeiten)
          if(this.selectedConfiguration) {
            const foundConfiguration : Work | undefined = this.configurationList.find((item: Work) => item.id === this.selectedConfiguration!.id)
            if(foundConfiguration) {
              this.selectedConfigurationIndex = this.configurationList.indexOf(foundConfiguration)
              this.selectedConfiguration = foundConfiguration
            }
          }
          this.setForm()
        } else {
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead').toString()
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch (e) {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onResize (): void {
      if(this.$refs.formSection && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.formSection as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 184px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    setForm (): void {
      if(!this.selectedConfiguration) {
        if(this.configurationList && this.configurationList[0]) {
          this.selectedConfigurationIndex = 0
          this.selectedConfiguration = this.configurationList[0]

          //@ts-ignore
          setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.configurationList[0].id])}, 100)
        }
      }

      this.code = this.selectedConfiguration && this.selectedConfiguration.code ? this.selectedConfiguration.code : null
      this.bezeichnung = this.selectedConfiguration && this.selectedConfiguration.getDescriptionLabel ? this.selectedConfiguration.getDescriptionLabel : null
      this.color = this.selectedConfiguration && this.selectedConfiguration.color ? this.selectedConfiguration.color : '#000000'

      if(this.selectedConfiguration && this.selectedConfiguration.descriptionList) {
        this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
          const foundDescription: WorkDescription | undefined = this.selectedConfiguration!.descriptionList.find((i: WorkDescription) => i.language === item.syzId)
          return {
            languageId: item.syzId,
            text: foundDescription ? foundDescription.description : ''
          }
        })
      } else {
        this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
          return {
            languageId: item.syzId,
            text: ''
          }
        })
      }

    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
      new Save(KeyActionEnum.save, this.save, this.resolver, null),
      new Cancel(KeyActionEnum.cancel, this.cancel, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)

    this.languagesDialogDescriptionData = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {
        languageId: item.syzId,
        text : ''
      }
    })

    setTimeout(() => { this.onResize() }, 0)
    this.fetchConfigurationList()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
